import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PrivacyPolicyContent } from './PrivacyPolicyContent';
import './PrivacyPolicyPage.css';

export function PrivacyPolicyPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const previousPage: unknown = location.state?.returnTo;
  const hasPortalReturnPage =
    typeof previousPage === 'string' &&
    previousPage.startsWith('/') &&
    !previousPage.startsWith('//') &&
    !previousPage.includes('\\') &&
    !/^\/datenschutz(?:[/?#]|$)/.test(previousPage);
  const returnTo = hasPortalReturnPage ? previousPage : '/start';

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Datenschutzerklärung (Entwurf) | RiviDent-Patientenportal';
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="privacy-page text-slate-700" aria-labelledby="privacy-heading">
      <div className="privacy-page__layout">
        <nav className="privacy-page__navigation" aria-label="Zurück zum Patientenportal">
          <Link
            to={returnTo}
            replace
            className="privacy-page__back-link"
            onClick={(event) => {
              if (
                hasPortalReturnPage &&
                window.history.state?.idx > 0 &&
                event.button === 0 &&
                !event.metaKey &&
                !event.ctrlKey &&
                !event.shiftKey &&
                !event.altKey
              ) {
                event.preventDefault();
                navigate(-1);
              }
            }}
          >
            <span aria-hidden="true">←</span>
            <span>Zurück zum Patientenportal</span>
          </Link>
        </nav>

        <aside className="privacy-page__draft" aria-label="Entwurfsstatus">
          <p className="privacy-page__draft-title">Entwurf – nicht für die Produktion freigegeben</p>
          <p>Markierte Angaben und Platzhalter sind noch zu prüfen.</p>
        </aside>

        <article className="privacy-page__content">
          <PrivacyPolicyContent />
        </article>
      </div>
    </main>
  );
}
